import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import PropTypes from "prop-types";
import CourseAllotmentGrid from "./CourseAllotmentGrid";
const AllottedCoursesDialog = ({ open, onClose, row, user }) => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // Fetch only allotted courses
  const fetchAllottedCourses = async () => {
    if (!row) return;

    setLoading(true);
    try {
      const { data } = await axios.get(`${API_BASE_URL}/api/exam-courses/allotted-courses`, {
        params: {
          client_id: Number(user.client_id),
          college_id: Number(user.college_id),

          program_id: Number(row.program_id),
          branch_id: Number(row.branch_id),
          regulation_id: Number(row.regulation_id),
          year_number: Number(row.year_number),
          semester_number: Number(row.semester_number),

          admittedbatch_id: Number(row.admittedbatch_id), // optional but recommended
        },
      });

      setCourses(
        (data.data || []).sort((a, b) => {
          // Base code (remove last char P for practical)
          const baseA = a.course_code.replace(/P$/, "");
          const baseB = b.course_code.replace(/P$/, "");

          if (baseA !== baseB) return baseA.localeCompare(baseB);

          // Same base → sort by type (T first, then P)
          if (a.course_type === "T" && b.course_type === "P") return -1;
          if (a.course_type === "P" && b.course_type === "T") return 1;

          return 0;
        })
      );
    } catch (error) {
      console.error("Error fetching allotted courses:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (open) {
      fetchAllottedCourses();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>
        Allotted Courses:: Internal Marks—
        {courses.length > 0 && (
          <>
            {" "}
            Program: {courses[0].program_name}, Branch: {courses[0].branch_name}, Admitted Batch:{" "}
            {courses[0].admittedbatch} , Year: {courses[0].year_number}, Semester:{" "}
            {courses[0].semester_number}
          </>
        )}
      </DialogTitle>

      <DialogContent dividers style={{ height: "650px" }}>
        {loading ? (
          <CircularProgress />
        ) : courses.length === 0 ? (
          <p>No allotted courses found.</p>
        ) : (
          <CourseAllotmentGrid courses={courses} />
        )}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            color: "green",
            backgroundColor: "#bfd2e4ff",
            "&:hover": { backgroundColor: "rgba(0,0,255,0.1)" },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AllottedCoursesDialog;
AllottedCoursesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,

  // row props
  row: PropTypes.shape({
    program_id: PropTypes.number.isRequired,
    branch_id: PropTypes.number.isRequired,
    regulation_id: PropTypes.number, // if optional use .number
    admittedbatch_id: PropTypes.number.isRequired,
    year_number: PropTypes.number.isRequired,
    semester_number: PropTypes.number.isRequired,
  }).isRequired,

  // user props
  user: PropTypes.shape({
    client_id: PropTypes.number.isRequired,
    college_id: PropTypes.number.isRequired,
    user_email: PropTypes.string,
  }).isRequired,

  showSnackbar: PropTypes.func,
};
